"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var houston_styles_1 = tslib_1.__importStar(require("@eduzz/houston-styles"));
var ModalContent = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)("div", tslib_1.__assign({}, rest, { children: children })));
};
/**
 * @deprecated Use Modal from Antd
 * https://ant.design/components/modal/
 */
exports.default = (0, houston_styles_1.default)(ModalContent, { label: 'hst-modal-content' })(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, houston_styles_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    padding: ", ";\n    overflow: auto;\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: 0%;\n\n    ", " {\n      padding: ", ";\n    }\n  "], ["\n    padding: ", ";\n    overflow: auto;\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: 0%;\n\n    ", " {\n      padding: ", ";\n    }\n  "])), theme.spacing.inset.sm, theme.breakpoints.down('sm'), theme.spacing.inset.xs);
});
var templateObject_1, templateObject_2;
